module.exports = __webpack_public_path__ + "media/images/flags/LU-9a5b94ec76d5258d79b5e3b2d7b16472.svg";